import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";

import { parse_url } from "../../../common/src";
import { TYPE_REGISTRATION } from "../../../platform/src/constants/widget-types";
import { checkBooleanParams } from './core/helpers/checkBooleanParams';
import * as constants from "../../../cp/components/EventPage/Widgets/NewRegistration/constants";
import { EventProvider } from "./context/EventContext";
import { LocaleContextProvider } from "../../../platform/src/context/LocaleContext";
import { WidgetContextProvider } from "../../../platform/src/context/WidgetContextProvider";
import { IS_FORM_VISIBLE, PARAM_LANG } from "./core/constants";
import { getWidgetRegistrationFields, getWidgetRegistration } from "../../../api/player";
import RegistrationWrapper from "./containers/RegistrationWrapper";

import "./styles.scss";

const App = () => {
    const request = parse_url(location.href);
    const watchKey = request.segments[1];
    const [isFormVisible, setIsFormVisible] = useState(true);
    const [isSuccess, setIsSuccess] = useState(true);
    const [registrationParams, setRegistrationParams] = useState({});
    const [clientEmail, setClientEmail] = useState('');
    const [isSettingLoading, setSettingLoading] = useState(true);
    const [isFieldsLoading, setFieldsLoading] = useState(true);
    const [settings, setSettings] = useState(null);
    const [registrationFields, setRegistrationFields] = useState(null);
    const [isFieldsUpdated, setFieldsUpdated] = useState(false);

    const checkHeight = () => {
        const height = window.document.body.offsetHeight;
        if (height !== window.innerHeight) {
            window.parent.postMessage({ setHeight: height }, '*');
        }
    };

    useEffect(() => {
        fetchWidgetSettings();
        fetchRegistrationFields();

        setInterval(checkHeight, 100);
        checkHeight();
        setRegistrationParams({
            ...registrationParams,
            [constants.PARENT_URL]: request?.getParameter(constants.PARENT_URL) ?? '',
            [constants.WIDGET_KEY]: request?.getParameter(constants.WIDGET_KEY) ?? '',
        });

        if (request?.getParameter(IS_FORM_VISIBLE)) {
            setIsFormVisible(checkBooleanParams(request?.getParameter(IS_FORM_VISIBLE), true));
        }
    }, []);

    useEffect(() => {
        isFieldsUpdated && fetchRegistrationFields();
    }, [isFieldsUpdated]);

    async function fetchWidgetSettings() {
        try {
            const response = await getWidgetRegistration(request?.getParameter(constants.WIDGET_KEY));
            setSettings(response);
            setSettingLoading(false);
        } catch (error) {
            console.error(error);
        }
    }

    async function fetchRegistrationFields() {
        try {
            const response = await getWidgetRegistrationFields(request?.getParameter(constants.WIDGET_KEY));
            setRegistrationFields(response);
            setFieldsLoading(false);
        } catch (error) {
            console.error(error);
        }
    }

    const handleSuccess = (client) => {
        setIsSuccess(true);
        setIsFormVisible(false);
        setClientEmail(client.email);
        window.parent.postMessage({ registrationComplete: client }, '*');
    }

    const handleError = (err) => {
        setIsSuccess(false);
    }

    const handleCloseNotification = () => {
        setIsFormVisible(true);
    };

    const handleUploadRegistrationFields = () => {
        setFieldsLoading(false);
    }

    return (
        <WidgetContextProvider isWidget widgetType={TYPE_REGISTRATION} settings={settings}>
            <LocaleContextProvider>
                <EventProvider
                    watchKey={watchKey}
                    showPreloader={isSettingLoading || isFieldsLoading}
                >
                    <main>
                        <RegistrationWrapper
                            isSuccess={isSuccess}
                            isFormVisible={isFormVisible}
                            params={registrationParams}
                            onSuccess={handleSuccess}
                            onError={handleError}
                            onCloseNotification={handleCloseNotification}
                            clientEmail={clientEmail}
                            widgetSettings={settings}
                            widgetFields={registrationFields}
                            onFieldsUpload={handleUploadRegistrationFields}
                            onChangeFormVisibility={setIsFormVisible}
                            onUpdateFields={setFieldsUpdated}
                        />
                    </main>
                </EventProvider>
            </LocaleContextProvider>
        </WidgetContextProvider>
    );
};

ReactDOM.render(
    <App />,
    document.getElementById('root')
);
